import React, { useState, useEffect, useContext } from 'react';
import '../../App.css';
import './visualisation.css';
import CSS from 'csstype';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

// icons

// classes
import { AddCatalog } from './aladin';
import { Aladin } from './aladin';
import PleaseWait from '../../tools/please-wait';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

// import state definition and functions.
import { setAladin, setAladinLoading } from './interactive-sessions-slice';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function VisualisationAladin(props: { running: boolean }) {
  // LOCAL STATE VARIABLES:

  // loading component.
  const sAladin: any = useAppSelector((state) => state.interactiveSessions.aladin);
  const sAladinLoading: boolean = useAppSelector(
    (state) => state.interactiveSessions.aladinLoading,
  );

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	Component code
  //
  //	------------------------------------------------------------

  if (props.running === true) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        }}
      >
        <Aladin
          divElementID="aladin-lite-div"
          aladin={sAladin}
          setAladin={setAladin}
          selectedIDs={[]}
          setSelectedIDs={undefined}
          setAladinRefresh={undefined}
          setLoadingComponent={setAladinLoading}
          running={true}
        />
        <PleaseWait text="Loading. Please wait....." visible={sAladinLoading} />
      </div>
    );
  } else {
    return (
      <Aladin
        divElementID="aladin-lite-div"
        aladin={sAladin}
        setAladin={setAladin}
        setLoadingComponent={setAladinLoading}
        running={false}
      />
    );
  }
  //
} // VisualisationAladin
